import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { buildBookingServiceMaps } from "@/app/utils/bookingServiceSelection";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import type { IOrgServiceTypeByFilter } from "../org/useOrgServicesByFilterAPI";

AxiosCurlirize(axios, () => {});

export interface IAtHomeSubServiceItem {
  id: string;
  title: string;
  serviceId?: string;
}

export interface IAtHomeSubServicesListResult {
  subServices: IAtHomeSubServiceItem[];
  subServiceToServiceIdMap: Record<string, string>;
}

export interface IAtHomeSubServicesResponse {
  status: boolean;
  message?: string;
  data?: {
    service_types?: Record<string, IOrgServiceTypeByFilter>;
  };
}

export const useAtHomeSubServicesListAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async (): Promise<IAtHomeSubServicesListResult> => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: AxiosResponse<IAtHomeSubServicesResponse> = await axios.get(
        PATIENT_WAITING_LIST?.AT_HOME_SUB_SERVICES_LIST?.baseURL ?? "",
        {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.status === true) {
        const serviceTypes = Object.values(response.data.data?.service_types ?? {});
        const { subServiceByIdMap, subServiceToServiceIdMap } = buildBookingServiceMaps(serviceTypes);
        return {
          subServices: Object.values(subServiceByIdMap).map((subService) => ({
            id: subService.sub_service_id,
            title: subService.sub_service_name,
            serviceId: subService.service_id,
          })),
          subServiceToServiceIdMap,
        };
      }

      return { subServices: [], subServiceToServiceIdMap: {} };
    } catch (error) {
      const axiosError = error as AxiosError;
      captureError(axiosError);
      sendCurl((axiosError.config as any)?.curlCommand);
      return { subServices: [], subServiceToServiceIdMap: {} };
    }
  }, [captureError, configuration.localStorage.ACCESS_TOKEN.key, sendCurl]);

  return execute;
};
